import 'react-app-polyfill/ie9';
import { start } from '@jutro/app';
import { getConfigValue } from '@jutro/config';
import { subscribe, unsubscribeAll, JUTRO_TOPICS } from '@jutro/events';
import { LocaleService, G11nstore } from 'gw-portals-i18n-react';
import wmicAMPDefaultThemeConfig from 'wmic-amp-digital-theme-styles';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import 'regenerator-runtime';

import App from './app/App';
import { initializeDataLayer } from './utils/dataLayer';
import { handleCallbackError } from './auth/callbackInterceptor';

import { configureLegacyComponentMap } from '@jutro/legacy/uiconfig';
configureLegacyComponentMap();

initializeDataLayer();

// Intercept access_denied callback BEFORE Jutro mounts — Jutro's LoginCallback
// hangs on a CORS-blocked /api/v1/sessions/me call, causing infinite load
if (handleCallbackError(appConfig)) {
    // Redirect in progress — do not start app
} else {

const recaptchaKey = appConfig.credentials.CAPTCHA_API_KEY;
const script = document.createElement('script');
script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`;
document.head.append(script);

const oneincScriptUrl = appConfig.serviceUrls.oneIncScriptUrl;

if (
    oneincScriptUrl &&
    !oneincScriptUrl.includes('{{') &&
    oneincScriptUrl.trim() !== ''
) {
    const oneIncScript = document.createElement('script');

    oneIncScript.type = 'text/javascript';
    oneIncScript.async = true;
    oneIncScript.defer = true;
    oneIncScript.src = oneincScriptUrl;

    window.__oneIncReady = false;
    window.__oneIncFailed = false;

    oneIncScript.onload = () => {
        window.__oneIncFailed = false;
        window.__oneIncReady = true;
        window.dispatchEvent(new Event('oneIncReady'));
    };

    oneIncScript.onerror = () => {
        window.__oneIncReady = false;
        window.__oneIncFailed = true;
        window.dispatchEvent(new Event('oneIncFailed'));
    };

    document.head.appendChild(oneIncScript);
}

const { authentication = {} } = appConfig;
const config = {
    ...authentication.servers.okta,
    ...appConfig.credentials
}

start(App, {
    rootId: 'root',
    messageLoader: LocaleService.loadMessages,
    coreMessageLoader: LocaleService.loadCoreMessages,
    config: [config],
    refreshOnLocaleChange: true,
    routerBasename: '/account-management',
    themeConfig: wmicAMPDefaultThemeConfig,
    g11nStore: G11nstore(),

    onInit: () => {
        LocaleService.register();
    },

    onRender: () => {
        // Unsubscribe from all default button and link click events
        unsubscribeAll([JUTRO_TOPICS.BUTTON_CLICKED, JUTRO_TOPICS.LINK_CLICKED, JUTRO_TOPICS.FETCH_REQUEST, JUTRO_TOPICS.FETCH_RESPONSE]);
    },

    appName: {
        id: 'digital.appName',
        defaultMessage: 'Account Management'
    },

    appDescription: 'Account Management',
    disableAuthForApplicationRoot: true,
});

} // end callback interceptor else block
